import ScrollMagic from "scrollmagic";

const SingleEvent = () => {
	const singleEvent = document.querySelector(".single-event");

	const sideBarSticky = () => {
		const postDetails = document.querySelector(".post-details");
		const postSidebar = document.querySelector(".post-sidebar");
		const postSidebarContent = document.querySelector(".post-sidebar > div");
		const getDuration = () => {
			return postDetails.offsetHeight - postSidebarContent.offsetHeight;
		};
		// 1
		const controller = new ScrollMagic.Controller();
		// 2.
		const scene = new ScrollMagic.Scene({
			triggerElement: postSidebar,
			triggerHook: 0.12,
			duration: getDuration,
		}).addTo(controller);
		// 3
		if (window.matchMedia("(min-width: 768px)").matches) {
			scene.setPin(postSidebar, { pushFollowers: false });
		}
		// 4
		window.addEventListener("resize", () => {
			if (window.matchMedia("(min-width: 768px)").matches) {
				scene.setPin(postSidebar, { pushFollowers: false });
			} else {
				scene.removePin(postSidebar, true);
			}
		});
	};

	const aoScriptUrl = `https://marketing.ayesa.com/acton/content/form_embed.js`;

	if (singleEvent) {
		if (window.initializedScripts.includes(aoScriptUrl)) {
			window.loadJS(aoScriptUrl, () => {
				window.initializedScripts.push(aoScriptUrl);
				sideBarSticky();
			});
		} else {
			sideBarSticky();
		}
	}
};

export default SingleEvent;
